"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1572],{

/***/ 49283:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo.07b04213.svg","height":30,"width":200});

/***/ }),

/***/ 1572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDebounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4841);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Options__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42237);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _public_logo_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49283);











var CityBar = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(7071)]).then(__webpack_require__.bind(__webpack_require__, 64050));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64050)
            ];
        }
    }
});
var Auth = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(8427), __webpack_require__.e(3948)]).then(__webpack_require__.bind(__webpack_require__, 1130));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1130)
            ];
        }
    },
    suspense: true
});
var Desktop = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_Options__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), options = ref[0], setOptions = ref[1];
    var _onSearch = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(value) {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(7066), __webpack_require__.e(3014)]).then(__webpack_require__.bind(__webpack_require__, 63014))
                        ];
                    case 1:
                        return [
                            4,
                            _state.sent().default(value)
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.ok) {
                            setOptions(res.data.data);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function _onSearch(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSearch = (0,_hooks_useDebounce__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_onSearch, 200);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container mx-auto py-2 flex",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 flex gap-5 items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "flex justify-center items-start",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    priority: true,
                                    src: _public_logo_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                    alt: "bungalowfinder logo",
                                    title: "BungalowFinder Logo"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CityBar, {
                            defaultValue: "Mississauga",
                            mode: "screen",
                            onSelect: function(city) {
                                return router.push("/city/".concat(city));
                            },
                            options: options,
                            onSearch: onSearch
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-1 flex justify-start items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                    className: "flex justify-between items-center w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/city/Mississauga",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Buy"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/homeevaluation",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Sell"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/newconstruction",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "New Developments"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/blogs",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Blog"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Loading..."
                                    })
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Auth, {})
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Desktop);


/***/ }),

/***/ 42237:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var options = [
    {
        id: "1",
        label: "Toronto",
        slug: "Toronto"
    },
    {
        id: "2",
        label: "Mississauga",
        slug: "Mississauga"
    },
    {
        id: "3",
        label: "Oakville",
        slug: "Oakville"
    },
    {
        id: "4",
        label: "Milton",
        slug: "Milton"
    },
    {
        id: "5",
        label: "Burlington",
        slug: "Burlington"
    },
    {
        id: "6",
        label: "Brampton",
        slug: "Brampton"
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (options);


/***/ })

}]);